import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/financeiro/notas-fiscais/loading";
import { NotasClient } from "@/client/modules/financeiro/notas-fiscais/notas-client";

export const Route = createFileRoute("/app/financeiro/notas-fiscais")({
  validateSearch: (s: Record<string, unknown>): { mes?: string } => ({ mes: s.mes as string | undefined }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("financeiro", "notasPage", deps)),
  head: () => pageHead("Notas fiscais"),
  pendingComponent: Loading,
  component: NotasFiscaisPage,
});

function NotasFiscaisPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("financeiro", "notasPage", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <div>
        <Link
          to="/app/financeiro"
          className="inline-flex items-center gap-1 text-xs text-slate-500 transition hover:text-slate-800"
        >
          <ChevronLeft className="h-3 w-3" /> Financeiro
        </Link>
      </div>
      <PageHeader title="Notas fiscais" description="Emissão de NFS-e dos atendimentos pagos, via Focus NFe." />
      <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-white px-3 py-2 shadow-soft">
        <Link
          to="/app/financeiro/notas-fiscais"
          search={{ mes: data.prevKey }}
          className="rounded-lg px-2 py-1 text-sm text-slate-500 hover:bg-slate-100"
        >
          ← Mês anterior
        </Link>
        <span className="text-sm font-semibold text-slate-700">{data.monthLabel}</span>
        <Link
          to="/app/financeiro/notas-fiscais"
          search={{ mes: data.nextKey }}
          className="rounded-lg px-2 py-1 text-sm text-slate-500 hover:bg-slate-100"
        >
          Próximo mês →
        </Link>
      </div>
      <NotasClient rows={data.rows} configured={data.configured} ambiente={data.ambiente} />
    </div>
  );
}
